import React from 'react';
import { Lock, ShieldCheck, BadgeCheck, Undo2 } from 'lucide-react';

/**
 * TrustBadges — additive visual trust layer.
 * Props:
 *   variant: 'banner' (default) | 'compact'
 *   t: optional translator; falls back to DE strings.
 * NO business logic, purely presentational.
 */
export function TrustBadges({ variant = 'banner', t }) {
  const tr = (key, fallback) => (t ? (t(key) || fallback) : fallback);

  const items = [
    { icon: Lock,         label: tr('trust_ssl',      'SSL-verschlüsselt'),   testId: 'trust-badge-ssl' },
    { icon: BadgeCheck,   label: tr('trust_verified', 'Verifizierte Fahrer'), testId: 'trust-badge-verified' },
    { icon: ShieldCheck,  label: tr('trust_escrow',   'Escrow-Schutz'),       testId: 'trust-badge-escrow' },
    { icon: Undo2,        label: tr('trust_cancel',   '24h Storno'),          testId: 'trust-badge-cancel' },
  ];

  if (variant === 'compact') {
    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] text-slate-500" data-testid="trust-badges-compact">
        {items.map(({ icon: Icon, label, testId }) => (
          <span key={testId} className="inline-flex items-center gap-1.5" data-testid={testId}>
            <Icon size={12} className="text-emerald-500" />
            {label}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3 p-3 rounded-xl bg-gradient-to-r from-emerald-50 via-white to-emerald-50 border border-emerald-100"
      data-testid="trust-badges-banner"
    >
      {items.map(({ icon: Icon, label, testId }) => (
        <div
          key={testId}
          className="flex items-center gap-2 text-xs font-medium text-slate-700"
          data-testid={testId}
        >
          <span className="w-7 h-7 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
            <Icon size={14} className="text-emerald-600" />
          </span>
          <span className="truncate">{label}</span>
        </div>
      ))}
    </div>
  );
}
